import React, { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'

import LotesSolicitadosRoutes from 'modules/lotesSolicitados/routes'
import MotoristasRoutes from 'modules/motorista/routes'
import PagamentoRoutes from 'modules/pagamentos/routes'
import { TermosUsoFactory } from 'modules/termosUso/factories/DetalhesTermosUso'
import { ForgotEmailProvider } from 'modules/user/hooks/forgotEmail'
import ErrorBoundary from 'shared/components/ErrorBoundary'

import { SignInFactory } from '../../modules/auth/factories/SignIn'
import CaminhoesRoutes from '../../modules/caminhao/routes'
import LotesRoutes from '../../modules/lotes/routes'
import { ForgotFactory } from '../../modules/user/factories/Forgot'
import { NewPasswordFactory } from '../../modules/user/factories/NewPassword'
import { SignUpFactory } from '../../modules/user/factories/SignUp'
import { FaleConoscoFactory } from '../../modules/faleConosco/factories/DetalhesFaleConosco'
import VeiculosRoutes from '../../modules/veiculos/routes'
import BasePage from '../components/BasePage'
import Dashboard from '../pages/Dashboard'
import { ShowEnvironmentNotReleased } from '../pages/ShowEnvironmentNotReleased'
import Route from './Route'
import UserRoutes from 'modules/user/routes'
import Redirect404 from './Redirect404'
import useGaTracker from 'shared/hooks/useGaTracker'
import { NewPasswordProvider } from 'modules/user/hooks/newPassword'
import { ChangeGestorFactory } from 'modules/user/factories/ChangeGestor'
import Onboarding from 'modules/onboarding'
import ValePedagioRoutes from 'modules/valePedagio/routes'
import ResendPhoto from 'modules/user/pages/ResendPhoto'

const Routes: FunctionComponent = () => {
  useGaTracker()

  return (
    <ShowEnvironmentNotReleased>
      <ErrorBoundary>
        <ForgotEmailProvider>
          <NewPasswordProvider>
            <Switch>
              <Route path="/" exact component={SignInFactory} />
              <Route path="/forgot" exact component={ForgotFactory} />

              <Route
                path="/new-password/:hash_autenticator"
                exact
                component={NewPasswordFactory}
              />
              <Route path="/signup" exact component={SignUpFactory} />
              <Route path="/reenviar-documento" exact component={ResendPhoto} />
              <Route
                path="/reset-register/:hash"
                exact
                component={ChangeGestorFactory}
              />
              <Route path="/onboard/:token" exact component={Onboarding} />
              <Route path="/dashboard" isPrivate exact component={Dashboard} />

              <BasePage>
                <MotoristasRoutes />
                <VeiculosRoutes />
                <LotesRoutes />
                <CaminhoesRoutes />
                <PagamentoRoutes />
                <LotesSolicitadosRoutes />
                <UserRoutes />
                <Route
                  path="/termos-uso"
                  isPrivate
                  exact
                  component={TermosUsoFactory}
                />
                <Route
                  path="/fale-conosco"
                  isPrivate
                  exact
                  component={FaleConoscoFactory}
                />
                <ValePedagioRoutes />
                <Redirect404 />
              </BasePage>
            </Switch>
          </NewPasswordProvider>
        </ForgotEmailProvider>
      </ErrorBoundary>
    </ShowEnvironmentNotReleased>
  )
}

export default Routes
